import type { CarrierPrice } from "~/shared/schemas/carrier-schema";

import { RateConfirmationCarrier } from "../rate-confirmation-modal/rate-confirmation-carrier.tsx";

export const CompressedCarrierCards = ({
	carriers,
	isSimulated = false,
	selectedCarrierIds = [],
	onCarrierSelection,
}: {
	carriers: CarrierPrice[];
	isSimulated?: boolean;
	selectedCarrierIds?: number[];
	onCarrierSelection?: (carrier: CarrierPrice) => void;
}) => {
	return (
		<>
			{carriers.map((carrier) => {
				const isCarrierSelected =
					selectedCarrierIds.includes(carrier.id) ?? isSimulated;
				return (
					<RateConfirmationCarrier
						key={carrier.id}
						carrier={carrier}
						isCarrierSelected={isCarrierSelected}
						onCarrierSelection={
							isSimulated
								? () => undefined
								: (onCarrierSelection ?? (() => undefined))
						}
					/>
				);
			})}
		</>
	);
};
